import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const ChildModel = t.model('ChildModel', {
  status: t.maybeNull(t.string),
  type: t.maybeNull(t.string),
});

export const TransactionListModel = t.model('TransactionListModel', {
  amount: t.string,
  child: ChildModel,
  createdAt: t.string,
  id: t.string,
  merchantName: t.string,
  mid: t.string,
  payerName: t.maybeNull(t.string),
  ref1: t.string,
  sourceOfFund: t.maybeNull(t.string),
  status: t.string,
  transactionId: t.string,
  tid: t.string,
  qrType: t.string,
});

export const TransactionModel = t
  .model('TransactionModel', {
    list: t.array(TransactionListModel),
    pagination: t.model('Pagination', {
      total: t.optional(t.number, 0),
      size: t.optional(t.number, 0),
      limit: t.optional(t.number, 0),
      start: t.optional(t.number, 0),
      links: t.model({
        prev: t.maybeNull(t.string),
        self: t.maybeNull(t.string),
        next: t.maybeNull(t.string),
      }),
    }),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default TransactionModel;
